export default __webpack_public_path__ + "static/media/cp_geo_jp.1be30dbe.svg";